
export default {
  data() {
    return {
      showWidget: false,
    }
  },
}
